import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { serviceLocals } from 'src/locals';
import { queryTypes, transactionTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupTransaction = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: transactionTypes.TransactionLookupDataType): AxiosPromise<transactionTypes.TransactionLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.transaction.lookupTransaction), {
    blockSpinner,
  });
};

export const transactionAdd = (
  form: transactionTypes.TransactionCreateDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<transactionTypes.TransactionCreateResultType> => {
  console.log(form, 'form');
  return axios.post(urlsConfig.transaction.transactionAdd, form, options);
};

export const transactionEdit = (
  form: transactionTypes.TransactionEditDataType,
): AxiosPromise<transactionTypes.TransactionEditResultType> => {
  return axios.patch(urlsConfig.transaction.transactionEdit, form, { blockErrorHandler: true });
};

export const transactionDelete = ({
  id,
}: transactionTypes.TransactionDeleteDataType): AxiosPromise<transactionTypes.TransactionDeleteResultType> => {
  return axios.delete(`${urlsConfig.transaction.transactionDelete}/${id}`);
};
